/**
 * Encodes a string, number, or boolean to a base64 string.
 * @param {string|number|boolean} value
 * @returns {string} base64 encoded string
 */
export function toBase64(value) {
  let str;
  if (typeof value === 'string') {
    str = value;
  } else if (typeof value === 'number' || typeof value === 'boolean') {
    str = String(value);
  } else {
    throw new TypeError('Value must be a string, number, or boolean');
  }

  if (typeof window !== 'undefined' && window.btoa) {
    // Browser environment
    return window.btoa(unescape(encodeURIComponent(str)));
  } else if (typeof Buffer !== 'undefined') {
    // Node.js environment
    return Buffer.from(str, 'utf-8').toString('base64');
  } else {
    throw new Error('No base64 encoding function available');
  }
}
